<template>
    <div class="wrapper">
        <div class="paddingLeftRight">
            <div class="buttonWrapper">
                <div class="flex" v-if="trackinglist_id">
                    <AdaButton :to="trackinglistpath" style="margin-right: 4%;width:300px;margin-bottom: 1.5rem;"
                               type="createButton large" title="Trackingliste bearbeiten"
                               icon="icon-edit" @click="editTrackinglist" :loading="addingTrackingList"></AdaButton>
                    <AdaButton type="createButton large grey" style="width:300px;margin-bottom: 1.5rem;"
                               title="Trackingliste löschen" icon="icon-delete"
                               @click="showDeleteModal = true"></AdaButton>
                </div>
                <div v-else>
                    <AdaButton type="createButton large" style="width:300px;margin-bottom: 1.5rem;"
                               title="Trackingliste hinzufügen" icon="icon-add"
                               @click="addTrackinglist" :loading="addingTrackingList"></AdaButton>
                </div>
            </div>
        </div>
        <div v-for="(insertionOrder, key, i) in insertionOrders" :key="i">
            <AccordionSection v-if="insertionOrder.length !== 0"
                              :title="key">
                <div class="hashOuterWrapper" v-if="key === 'Run of Site' || key === 'Festplatzierung'">
                    <div class="hashWrapper">
                        <div class="engagementHash" :title="insertionOrder[0].engagement_hash">
                            {{insertionOrder[0].engagement_hash}}
                            <span class="icon icon-clipboard"
                                  @click="copyToClipboard(insertionOrder[0].engagement_hash)"></span>
                        </div>
                    </div>

                </div>
                <PlacementSection :data="insertionOrder"></PlacementSection>
            </AccordionSection>
        </div>
        <Confirm title="Trackingliste löschen" :show="showDeleteModal" @close="showDeleteModal = false"
                 @oncancel="showDeleteModal = false" :options="{cancel: {title: 'Abbrechen', icon: 'icon-close'}}"
                 @onok="updateMedium(null)" :okLoading="deletingTrackinglist">
            <span>Trackingliste wirklich löschen ?</span>
        </Confirm>
    </div>
</template>

<script>
    import AdaButton from "../../../components/buttons/AdaButton";
    import AccordionSection from "../AccordionSection";
    import PlacementSection from "./PlacementSection";
    import {RepositoryFactory} from "../../../scripts/RepositoryFactory";
    import Confirm from "../../../components/dialog/Confirm";

    const TrackinglistRepository = RepositoryFactory.get('trackingLists');
    const MediumRepository = RepositoryFactory.get('mediums');
    export default {
        name: "MediumContent",
        components: {
            Confirm,
            PlacementSection,
            AccordionSection,
            AdaButton
        },
        props: ["dynamicProps"],
        data: function () {
            return {
                showDeleteModal: false,
                trackinglist_id: this.dynamicProps.tracking_list_id,
                trackinglistpath: `/campaigns/${this.$route.params.id}/trackinglist/${this.dynamicProps.tracking_list_id}`,
                deletingTrackinglist: false,
                addingTrackingList: false,
                localDynamicProps: JSON.parse(JSON.stringify(this.dynamicProps)),
            }
        },
        computed: {
            insertionOrders: function () {
                let obj = {
                    "Run of Channel": [],
                    "Run of Site": [],
                    "Festplatzierung": []
                };
                this.$attrs.insertion_order.forEach(function (io) {
                    obj[io.type].push(io);
                });
                return obj;
            },
            hashFp: function () {
                let hash = '';
                if (this.insertionOrders['Festplatzierung'].length > 0) {
                    hash = this.insertionOrders['Festplatzierung'][0]['engagement_hash'];
                }
                return hash;
            },
            hashRos: function () {
                let hash = '';
                if (this.insertionOrders['Run of Site'].length > 0) {
                    hash = this.insertionOrders['Run of Site'][0]['engagement_hash'];
                }
                return hash;
            }
        },
        methods: {
            alert: function (val) {
                this.$noty.show(val);
            },
            addTrackinglist: async function () {
                this.addingTrackingList = true;
                try {
                    const {data} = await TrackinglistRepository.createTrackingList({
                        'name': 'Tracking ' + (this.localDynamicProps.name ? this.localDynamicProps.name : this.capitalize(this.localDynamicProps.type.toLowerCase())),
                        'is_template': 0,
                        'target_medium': this.localDynamicProps.type
                    });
                    this.trackinglist_id = data.trackingList.id;
                    //update actual medium
                    this.updateMedium(this.trackinglist_id);
                } catch (e) {
                    this.$noty.error(e.message);
                    console.error(e);
                    this.addingTrackingList = false;
                }
            },
            updateMedium: async function (trackinglistID) {
                this.deletingTrackinglist = true;
                try {
                    await MediumRepository.updateMedium(this.localDynamicProps.id, {'tracking_list_id': trackinglistID});
                    let oldTrckLstID = this.localDynamicProps.tracking_list_id;
                    this.localDynamicProps.tracking_list_id = trackinglistID;
                    if (trackinglistID) {
                        this.editTrackinglist();
                    } else {
                        this.deleteTrackinglist(oldTrckLstID);
                    }
                    this.$root.$emit('updateMediumDueTrackinglistChange', this.localDynamicProps);
                } catch (e) {
                    this.$noty.error(e.message);
                    console.error(e);
                    this.deletingTrackinglist = false;
                    this.addingTrackingList = false;
                }
            },
            capitalize: function (string) {
                return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
            },
            editTrackinglist: function () {
                this.addingTrackingList = false;
                this.$router.push({
                    name: 'trackinglist',
                    params: {id: this.$route.params.id, trackinglist_id: this.localDynamicProps.tracking_list_id}
                });
            },
            deleteTrackinglist: async function (trckLstID) {
                try {
                    await TrackinglistRepository.deleteTrackingList(trckLstID);
                    this.$store.commit('campaign/deleteTrackingList', trckLstID);
                    this.trackinglist_id = null;
                    this.deletingTrackinglist = false;
                    this.showDeleteModal = false;
                } catch (e) {
                    this.$noty.error(e.message);
                    console.error(e);
                }
            },
            copyToClipboard: function (val) {
                let dummy = document.createElement("textarea");
                document.body.appendChild(dummy);
                dummy.value = val;
                dummy.select();
                try {
                    document.execCommand('copy');
                    this.$noty.success('Kopiert.');
                } catch (e) {
                    console.error(e);
                    this.$noty.error('Fehler bei der Speicherung in die Zwischenablage');
                }
                document.body.removeChild(dummy);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .wrapper {
        padding-top: 2em;
    }

    .paddingLeftRight {
        padding: 0 1.5em;
    }

    .buttonWrapper {
        display: inline-block;
    }

    .flex {
        display: flex;
        flex-flow: row;

    }

    .inputMargin {
        margin-bottom: 25px;
        margin-right: 25px;
    }

    .engagementHash {
        background: $grey;
        padding: 0.5rem 2.3rem 0.5rem 0.6rem;
        margin-top: 20px;
        position: relative;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        width: 100%;

        .icon {
            position: absolute;
            right: 0.5rem;
            font-size: 1.3rem;
            cursor: pointer;
        }
    }

    .hashWrapper {
        display: block;
        padding-left: .5rem;
        padding-right: 1rem;
        margin-left: calc(100% / 2);
    }

    .hashOuterWrapper {
        width: 100%;
        padding-bottom: 1rem;
        margin-bottom: 1rem;
        border-bottom: 1px solid $grey;
    }
</style>